import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';

import TableRender from './TableRender';

import './index.css';

function Table({ spol }) {
  const [data, setData] = useState([]);
  const columns = useMemo(
    () => [
      {
        Header: 'POREDAK',
        columns: [
          {
            Header: 'Pl',
            accessor: 'PL'
          },
          {
            Header: 'Ime i prezime',
            accessor: 'PLIVACN'
          },
          {
            Header: 'God',
            accessor: row => row.DATUM.substr(0, 4)
          },
          {
            Header: 'Klub',
            accessor: 'KLUB'
          },
          {
            Header: 'Bod',
            accessor: 'BOD'
          }
        ]
      },
      {
        Header: 'SLOBODNO',
        columns: [
          {
            Header: '100m',
            accessor: 'V02'
          },
          {
            Header: '200m',
            accessor: 'V03'
          },
          {
            Header: '400m',
            accessor: 'V04'
          },
          {
            Header: '800m',
            accessor: 'V05'
          }
        ]
      },
      {
        Header: 'LEĐNO',
        columns: [
          {
            Header: '100m',
            accessor: 'V08'
          },
          {
            Header: '200m',
            accessor: 'V09'
          }
        ]
      },
      {
        Header: 'PRSNO',
        columns: [
          {
            Header: '100m',
            accessor: 'V11'
          },
          {
            Header: '200m',
            accessor: 'V12'
          }
        ]
      },
      {
        Header: 'LEPTIR',
        columns: [
          {
            Header: '100m',
            accessor: 'V14'
          },
          {
            Header: '200m',
            accessor: 'V15'
          }
        ]
      },
      {
        Header: 'MJEŠOVITO',
        columns: [
          {
            Header: '200m',
            accessor: 'V16'
          },
          {
            Header: '400m',
            accessor: 'V17'
          }
        ]
      }
    ],
    []
  );

  useEffect(() => {
    axios.get('http://croswimspace.org/minigp/getMiniGP.php').then(response => {
      setData(response.data);
    });
  }, []);

  console.log(data);

  return (
    <TableRender
      columns={columns}
      data={data.filter(row => row.SPOL === spol)}
    />
  );
  // return <div data={data}>PROBA</div>;
}

export default Table;
